import axios from "axios";
import { Response } from "../../../shared/models/Response";
import { AllUsersModel } from "../models/AllUsersModel";
import { UserInformationModel } from "../models/UserInformationModel";
import { UserModel } from "../models/UserModel";
import { UserPagination } from "../models/UserPagination";
import { UserQuery } from "../models/UserQuery";
import { UserStatus } from "../models/UserStatus";

export class UserService {
  private baseUrl: string;

  constructor() {
    this.baseUrl = `${process.env.VUE_APP_USERS_API}/users`;
  }

  async addUser(user: UserModel): Promise<Response<string | void>> {
    return (await axios.post(this.baseUrl, user)).data;
  }

  async checkIfExistByUser(user: string): Promise<Response<void>> {
    const serviceURL = `${this.baseUrl}/exist-by-user`;

    const params = {
      params: {
        nameUser: user
      }
    };

    const response = await axios.get(serviceURL, params);
    return response.data;
  }

  async getUserById(
    id: string
  ): Promise<Response<UserInformationModel | void>> {
    const serviceURL = `${this.baseUrl}/${id}`;
    const response = await axios.get(serviceURL);
    return response.data;
  }

  async getUserVersionById(
    id: string
  ): Promise<Response<UserInformationModel | void>> {
    const serviceURL = `${this.baseUrl}/version/${id}`;
    const response = await axios.get(serviceURL);
    return response.data;
  }

  async updateUser(
    id: string,
    user: UserModel
  ): Promise<Response<string | void>> {
    const serviceURL = `${this.baseUrl}/${id}`;
    const response = await axios.put(serviceURL, user);
    return response.data;
  }

  async getUserByFilters(query: UserQuery): Promise<Response<UserPagination>> {
    const serviceURL = `${this.baseUrl}/find-by-filters`;
    const response = await axios.get(serviceURL, { params: query });
    return response.data;
  }

  async getUsersByFiltersArrayUsersCrud(
    query: UserQuery
  ): Promise<Response<UserPagination>> {
    const serviceURL = `${this.baseUrl}/find-by-filters-crud`;
    const response = await axios.get(serviceURL, { params: query });
    return response.data;
  }

  async getUsersByFiltersArray(
    query: UserQuery
  ): Promise<Response<UserPagination>> {
    const serviceURL = `${this.baseUrl}/by-filter-array`;
    const response = await axios.get(serviceURL, { params: query });
    return response.data;
  }

  async getUsersByIdsArray(query: UserQuery): Promise<Response<UserStatus[]>> {
    const serviceURL = `${this.baseUrl}/by-array`;
    const response = await axios.get(serviceURL, { params: query });
    return response.data;
  }

  async getUserBasicInfo(id: string): Promise<Response<UserStatus>> {
    const serviceURL = `${this.baseUrl}/basic-info/${id}`;
    const response = await axios.get(serviceURL);
    return response.data;
  }

  async getUserBasicInfoIA(id: string): Promise<Response<UserStatus>> {
    const serviceURL = `${this.baseUrl}/basic-info-ia/${id}`;
    const response = await axios.get(serviceURL);
    return response.data;
  }

  async deleteUser(id: string): Promise<Response<string | void>> {
    return (await axios.delete(`${this.baseUrl}/${id}`)).data;
  }

  async updateStateUserById(
    id: string,
    state: string
  ): Promise<Response<string | void>> {
    const serviceUrl = `${this.baseUrl}/state/${id}/${state}`;
    const response = await axios.put(serviceUrl);
    return response.data;
  }

  async getAllResponsables(): Promise<Response<void | AllUsersModel[]>> {
    return (await axios.get(`${this.baseUrl}/`)).data;
  }

  async checkIfExistByEmail(query: {
    userEmail: string;
    userId: string;
  }): Promise<Response<UserPagination>> {
    const serviceURL = `${this.baseUrl}/exist-by-email`;

    const params = {
      params: {
        userEmail: query.userEmail,
        userId: query.userId
      }
    };

    const response = await axios.get(serviceURL, params);
    return response.data;
  }
  async getOtherPhone(id: string) {
    const serviceURL = `${this.baseUrl}/phoneModel/${id}`;
    const response = await axios.get(serviceURL);
    return response.data;
  }
}
